export default "__VITE_ASSET__Bl7MVyk6__"